module.exports = __webpack_public_path__ + "img/Application_2.0bd618b7.png";